export default __webpack_public_path__ + "static/media/ryan-TA.9f6403dd.png";